import React, { useState, useEffect } from "react";
import Breadcrumb from "../../../components/common/Breadcrumb/Breadcrumb";
import TextInput from "../../../components/common/TextInput/TextInput";
import Title from "../../../components/common/Title/Title";
import { Button } from "react-bootstrap";
import httpclient from "../../../components/httpclient";
import HeaderInfo from "../../finance/report/pawn_transaction/components/GadaiReportDetail/HeaderInfo";
import { convertGadaiReportDetail } from "../../finance/report/helpers/convertGadaiReportDetail";
import { Divider } from "antd";
import BillInstallment from "./components/BillInstallment";
import ModalNextBill from "./components/ModalNextBill";
import ModalPaymentMethod from "./components/ModalPaymentMethod";
import { paymentOption } from "../constants";
import { convertBankList } from "../../../components/helpers/convertBankList";
import SwalToast from "../../../components/helpers/SwalToast";
import { getLabel } from "./helpers/getLabel";
import { getOngoingVa } from "./helpers/getOngoingVa";
import ModalOngoingVa from "./components/ModalOngoingVa";
import IsEmpty from "../../../components/helpers/IsEmpty";
import { isLastInstallmentChecked } from "./helpers/isLastInstallmentChecked";
import ModalSchedule from "./components/ModalSchedule";
import ModalUploadDocument from "./components/ModalUploadDocument";
import { AxiosCustomPost } from "../../../components/axios/AxiosCustom";
import Cookies from "js-cookie";
import Config from "../../../components/axios/Config";
import BillBalloon from "./components/BillBalloon";
import convertGadaiDetail from "./helpers/convertGadaiDetail";

export default function Redeem() {
  const [sbgCode, setSbgCode] = useState("");
  const [errors, setErrors] = useState({});
  const [gadaiDetailData, setGadaiDetailData] = useState({});
  const [installments, setInstallments] = useState([]);
  const [selected, setSelected] = useState([]);
  const [imgLink, setImgLink] = useState("");
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [totalBill, setTotalBill] = useState(0);
  const [totalVoucherAmount, setTotalVoucherAmount] = useState(0);
  const [modalNextBill, setModalNextBill] = useState(false);
  const [modalOngoingVa, setModalOngoingVa] = useState(false);
  const [modalPaymentMethod, setModalPaymentMethod] = useState(false);
  const [nextBillInstallment, setNextBillInstallment] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState(paymentOption[0].value);
  const [bankList, setBankList] = useState([]);
  const [bankValue, setBankValue] = useState();
  const [VA, setVA] = useState('');
  const [detailTransaction, setDetailTransaction] = useState({});
  const [ongoingVa, setOngoingVa] = useState({});
  const [loading, setLoading] = useState(false);
  const [modalSchedule, setModalSchedule] = useState(false);
  const [returnData, setReturnData] = useState({});
  const [isNeedUploadSbg, setIsNeedUploadSbg] = useState(false);
  const [modalUploadDocument, setModalUploadDocument] = useState(false);
  const [documentpaidOff, setDocumentPaidOff] = useState({});
  const [sbgPicture, setSbgPicture] = useState([]);
  const [customerKtp, setCustomerKtp] = useState([]);
  const [recipientKtp, setRecipientKtp] = useState([]);
  const [gadaiById, setGadaiById] = useState({});
  const [isSameRecipient, setIsSameRecipient] = useState(true);
  const [detailPayment, setDetailPayment] = useState({});
  const [installmentsNotConverted, setInstallmentsNotConverted] = useState([]);

  const handleChange = (event) => {
    setSbgCode(event.target.value);

    if (errors.sbgCode) {
      setErrors({});
    }
  };

  const validate = () => {
    const newErrors = {};

    if (!sbgCode || sbgCode === "") {
      newErrors.sbgCode = "Nomor SBG tidak boleh kosong";
    }
    return newErrors;
  };

  const handleSearch = (event) => {
    event.preventDefault();
    const newErrors = validate();

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      getDetail(sbgCode);
    }
  };

  const handleEnter =
    (type = "enter") =>
      (event) => {
        const { value } = event.target;
        if (event.keyCode === 13) {
          getDetail(value)
        };
      };

  const getDetail = (sbg, transferred = false) => {
    setSbgCode(sbg)

    if (!transferred) {
      setTotalBill(0)
      setTotalVoucherAmount(0)
    }
    let url = `${process.env.REACT_APP_BASE_API_URL}gadai/${0}/report?sbg_code=${sbg}`;
    httpclient
      .GET(url)
      .then((response) => {
        let converted = convertGadaiReportDetail(response.data.data, handleOpenPreview, null)
        let tempInstallments = []
        setInstallmentsNotConverted(response.data.data.gadai_installments)
        setGadaiDetailData(converted);
        let temp = []
        converted.installment.map((item) => {
          if (item.isCurrentPeriod || item.isPeriodBeforeToday) {
            tempInstallments.push({ ...item, isChecked: false })
          }
          if (item.isPeriodAfterToday) {
            temp.push(item)
          }
        })
        setNextBillInstallment(temp)
        if (transferred) {
          tempInstallments = installments.map(t1 => ({ ...t1, ...converted.installment.find(t2 => t2.installmentId === t1.installmentId) }))
        }
        setInstallments(tempInstallments);
        GetDetailById(converted.id)
        if (converted.offer.paymentType === 'Balloon Payment')
          getDetailPayment(converted.id, converted)
      })
      .catch((err) => {
        setGadaiDetailData({})
        console.log('err detail redeem', err?.response?.data ? err.response.data : err)
      });
  }

  const GetDetailById = (id) => {
    setLoading(true)
    let url = `${process.env.REACT_APP_BASE_API_URL}gadai/${id}`;
    httpclient
      .GET(url)
      .then((response) => {
        // setGadaiByIdConverted(convertGadaiDetail(response.data.data))
        setGadaiById(response.data.data)
        setOngoingVa(getOngoingVa(response.data.data))
        // console.log('tes', response.data.data)
        if (response.data.data.status === 'done' && IsEmpty(response.data.data.form_payment_picture)) {
          setIsNeedUploadSbg(true)
        } else {
          setIsNeedUploadSbg(false)
        }
      })
      .catch((err) => {
        console.log('err GetDetailById', err.response.data ? err.response.data : err)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const handleOpenPreview = (src) => () => {
    setImgLink(src);
    setIsPreviewOpen(true);
  };

  const onCheck = (e, id) => {
    let installmentsTemp = [...installments]
    let selectedTemp = []
    let total = 0
    let totalVoucher = 0
    installmentsTemp.forEach((element, index) => {
      if (element.periodNumber === id) {
        installmentsTemp[index] = { ...element, isChecked: e.target.checked };
        // if (e.target.checked) {
        //   selectedTemp.push({ ...element, isChecked: e.target.checked })
        // } else {
        //   selectedTemp.splice(index, 1);
        // }
        // if (e.target.checked) {
        //   setTotalBill(total += installmentsTemp[index].totalBillRaw)
        // } else {
        //   setTotalBill(total -= installmentsTemp[index].totalBillRaw)
        // }
      }
      if (!e.target.checked) {
        if (element.periodNumber > id) {
          installmentsTemp[index] = { ...element, isChecked: e.target.checked };
        }
      }
    });
    installmentsTemp.map((item, index) => {
      if (item.isChecked) {
        selectedTemp.push(item)
        setTotalBill(total += item.totalBillRaw)
        setTotalVoucherAmount(totalVoucher += item.voucher.amount)
      }
      if (!e.target.checked && installments[0].periodNumber === id) {
        setTotalBill(0)
      }
    })
    setSelected(selectedTemp)
    setInstallments(installmentsTemp)
  }

  const getBankList = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}bank`;
    httpclient
      .GET(url)
      .then((response) => {
        setBankList(convertBankList(response.data.data));
      })
      .catch((err) => {
        console.log('err getBankList', err.response.data ? err.response.data : err)
      });
  };

  useEffect(() => {
    getBankList();
  }, []);

  const closeModal = () => {
    setModalPaymentMethod(false)
    setBankValue()
    setPaymentMethod(paymentOption[0].value)
  }

  const submitTransferPayment = () => {
    let gadai_installment_id = []
    let bank = getLabel(bankList, bankValue)
    selected.map(item => gadai_installment_id.push(item.installmentId))
    let data = {
      gadai_id: gadaiDetailData.id,
      gadai_installment_id,
      bank: bank.toLowerCase(),
      ...returnData
    }
    // console.log('selected', selected)
    // console.log('transfer', data); return
    setSubmitting(true);
    httpclient
      .POST(`${process.env.REACT_APP_BASE_API_URL}gadai/payment-va`, data)
      .then((response) => {
        console.log(response.data.data);
        setVA(response.data.data.gadai_transfer.office_account_number)
        setDetailTransaction(response.data.data)
        // setModalPaymentMethod(false)
        SwalToast.fire({
          icon: "success",
          title: response.data.message,
        });
      })
      .catch((error) => {
        if (error.response) {
          console.log(error.response.data.error);
          SwalToast.fire({
            icon: "error",
            title: error?.response?.data?.error?.message,
          });
        } else {
          console.log(error);
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      })
      .finally(() => {
        setSubmitting(false);
        getDetail(sbgCode, true)
      });
  }

  const submitCashPayment = () => {
    let gadai_installment_id = []
    selected.map(item => gadai_installment_id.push(item.installmentId))
    let data = {
      gadai_id: gadaiDetailData.id,
      gadai_installment_id,
      ...returnData
    }
    console.log(data);
    setSubmitting(true);
    httpclient
      .POST(`${process.env.REACT_APP_BASE_API_URL}gadai/payment-cash`, data)
      .then((response) => {
        console.log(response);
        getDetail(sbgCode)
        setSelected([])
        setBankValue()
        setModalPaymentMethod(false)
        SwalToast.fire({
          icon: "success",
          title: response.data.message,
        });
      })
      .catch((error) => {
        if (error.response) {
          console.log(error.response.data.error);
          SwalToast.fire({
            icon: "error",
            title: error?.response?.data?.error?.message,
          });
        } else {
          console.log(error);
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      })
      .finally(() => {
        setSubmitting(false);
      });
  }

  const getDetailTransfer = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}gadai/${gadaiDetailData.id}/waiting-payment`;
    httpclient
      .GET(url)
      .then((response) => {
        if (response.data.data.gadai_transfer.status !== 'waiting-transfer') {
          if (response.data.data.gadai_transfer.status === 'transferred') {
            SwalToast.fire({
              icon: "success",
              title: 'Pembayaran Sudah Diterima',
            });
          } else if (response.data.data.gadai_transfer.status === 'expired') {
            SwalToast.fire({
              icon: "error",
              title: ' Pembayaran Gagal, No. Virtual Account Expired',
            });
          }
          setModalOngoingVa(false)
          getDetail(sbgCode)
          setVA('')
          setModalPaymentMethod(false)
        }
      })
      .catch((err) => {
        console.log('err detailTransfer', err.response.data ? err.response.data : err)
      });
  }

  const getDetailPayment = (id, data) => {
    let url = `${process.env.REACT_APP_BASE_API_URL}gadai/${id}/payment-detail`;
    httpclient
      .GET(url)
      .then((response) => {
        // console.log('getDetailPayment', response.data.data)
        setDetailPayment(convertGadaiDetail(response.data.data,data))
      })
      .catch((err) => {
        console.log('err getDetailPayment', err.response.data ? err.response.data : err)
      });
  }

  const onClickPay = () => {
    if (gadaiDetailData.offer.gadaiType !== 'Reguler') {
      if (gadaiDetailData.offer.paymentType === 'Installment' && !isLastInstallmentChecked(installmentsNotConverted, selected)) {
        setModalPaymentMethod(true)
      } else {
        setModalSchedule(true)
      }
    } else {
      setModalPaymentMethod(true)
    }
  }

  const submitReturnData = (dataReturn) => {
    setReturnData(dataReturn)
    setModalPaymentMethod(true)
    setModalSchedule(false)
  }

  const handleUploadImage = (type) => (options) => {
    const { onSuccess, onError, file } = options;

    const fmData = new FormData();
    fmData.append("file", file);

    let url = `${process.env.REACT_APP_BASE_API_URL}upload-image`;
    AxiosCustomPost(
      url,
      fmData,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
        "content-type": "multipart/form-data",
      }),
      (response) => {
        onSuccess(response.data.data, file);
        setDocumentPaidOff((prev) => ({
          ...prev,
          sbgPicture:
            type === "sbgPicture"
              ? response.data.data.object_path
              : prev.sbgPicture,
          customerKtp:
            type === "customerKtp"
              ? response.data.data.object_path
              : prev.customerKtp,
          recipientKtp:
            type === "recipientKtp"
              ? response.data.data.object_path
              : prev.recipientKtp,
        }));
      },
      (error) => {
        onError({ error });
      }
    );
  };

  const handleImageChange =
    (type) =>
      ({ fileList }) => {
        let tempFileList = [...fileList];
        tempFileList = tempFileList.slice(-1);

        tempFileList = tempFileList.map((file) => {
          if (file.response) {
            file.url = file.response.url;
          }
          return file;
        });
        if (type === "sbgPicture") {
          setSbgPicture(tempFileList);
        } else if (type === "customerKtp") {
          setCustomerKtp(tempFileList)
        } else if (type === "recipientKtp") {
          setRecipientKtp(tempFileList)
        }
        if (errors[type]) {
          setErrors((prev) => ({
            ...prev,
            [type]: null,
          }));
        }
      };


  const validateDocument = (data) => {
    const newErrors = {};

    if (!data.sbgPicture || data.sbgPicture === "") {
      newErrors.sbgPicture = "SBG pelunasan harus diupload";
    }
    if (!data.customerKtp || data.customerKtp === "") {
      newErrors.customerKtp = "KTP nasabah harus diupload";
    }
    if (!isSameRecipient) {
      if (!data.recipientKtp || data.recipientKtp === "") {
        newErrors.recipientKtp = "KTP penerima harus diupload";
      }
    }
    return newErrors;
  };

  const submitDocument = () => {
    const newErrors = validateDocument(documentpaidOff);

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    } else {
      let data = {
        form_payment_picture: documentpaidOff.sbgPicture,
        ktp_payment_picture: documentpaidOff.customerKtp,
        ktp_recipient_picture: isSameRecipient ? documentpaidOff.customerKtp : documentpaidOff.recipientKtp,
        same_ktp_recipient_payment: isSameRecipient
      }
      console.log(data);
      setSubmitting(true);
      httpclient
        .PUT(`${process.env.REACT_APP_BASE_API_URL}gadai/${gadaiDetailData.id}/payment-picture`, data)
        .then((response) => {
          console.log(response);
          SwalToast.fire({
            icon: "success",
            title: response.data.message,
          });
          setModalUploadDocument(false)
          getDetail(sbgCode)
        })
        .catch((error) => {
          console.log(error)
          if (error.response) {
            console.log(error.response.data.error);
            SwalToast.fire({
              icon: "error",
              title: error?.response?.data?.error?.message,
            });
          } else {
            console.log(error);
            SwalToast.fire({
              icon: "error",
              title: "Whoops, something went wrong",
            });
          }
        })
        .finally(() => {
          setSubmitting(false);
        });
    }
  }

  const isDisablePayButton = () => {
    let disable = false
    if (submitting) {
      disable = true
    } else {
      if (gadaiDetailData?.offer?.paymentType === 'Installment') {
        if (selected.length < 1) {
          disable = true
        }
      } else if (gadaiDetailData?.offer?.paymentType === 'Balloon Payment') {
        if (gadaiDetailData?.headerInfo?.status.label === 'Menunggu Pembayaran') {
          console.log('a')
          disable = true
        }
      }
    }
    return disable
  }

  return (
    <div>
      <div className="px-3">
        <div className="py-4 d-flex flex-column" style={{ fontSize: "13px" }}>
          <Title text={"Tebus Gadai"} />
          <Breadcrumb current={"Tebus Gadai"} />
        </div>

        <div className="d-flex input-bar">
          <TextInput
            id={"sbgCode"}
            label={"Nomor SBG"}
            width={"25%"}
            handleChange={handleChange}
            handleEnter={handleEnter}
            placeholder={"Masukkan Nomor SBG"}
            errorText={errors.sbgCode}
          />
          <div className="input-bar">
            <Button
              variant="warning"
              style={{ marginTop: 27, color: "#fff" }}
              className="btn-action"
              onClick={handleSearch}
            >
              Cari
            </Button>
          </div>
        </div>
      </div>

      {
        gadaiDetailData.id &&
        <div className="detail-card-container">
          <div className="d-flex">
            <HeaderInfo
              gadaiID={gadaiDetailData.id}
              data={{
                commonInfo: gadaiDetailData.commonInfo,
                headerInfo: gadaiDetailData.headerInfo,
              }}
            />
          </div>
          <Divider dashed className="detail-divider" />

          {
            gadaiDetailData.offer.paymentType === 'Installment' ?
              <BillInstallment data={installments} onCheck={onCheck} totalBill={totalBill} />
              : <BillBalloon data={detailPayment} />
          }

          <div className="d-flex justify-content-between mt-3">
            {
              ongoingVa?.transaction?.length > 0 ?
                <Button
                  disabled={submitting}
                  onClick={() => setModalOngoingVa(true)}
                  className="btn-action"
                  style={{
                    height: 36,
                    margin: 5,
                    background: "#fff",
                    border: "0.75px solid #F5CB58",
                    color: "#fff",
                    backgroundColor: '#F5CB58'
                  }}
                >
                  Lihat Nomor VA yang sudah Terbit
                </Button>
                :
                <div></div>
            }
            {
              isNeedUploadSbg ?
                <div className="d-flex align-items-center justify-content-end mt-3">
                  <Button
                    disabled={submitting}
                    onClick={() => setModalUploadDocument(true)}
                    variant="primary"
                    className="btn-action btn-add"
                  >
                    Upload Dokumen Pelunasan
                  </Button>
                </div>
                : gadaiById.status !== 'done' && gadaiById.status !== 'waiting-confirmation-delivery' &&
                <div className="d-flex align-items-center justify-content-end mt-3">
                  {
                    gadaiDetailData.offer.paymentType === 'Installment' &&
                    <Button
                      disabled={submitting}
                      onClick={() => setModalNextBill(true)}
                      className="btn-action"
                      style={{
                        height: 36,
                        margin: 5,
                        background: "#fff",
                        border: "0.75px solid #DCDCDC",
                        color: "#2C465C",
                      }}
                    >
                      Lihat Cicilan Berikutnya
                    </Button>
                  }
                  <Button
                    disabled={isDisablePayButton()}
                    variant="primary"
                    className="btn-action btn-add"
                    style={{ width: 120, height: 36, margin: 5 }}
                    onClick={onClickPay}
                  >
                    Bayar
                  </Button>
                </div>
            }
          </div>
        </div>
      }
      <ModalNextBill
        visible={modalNextBill}
        handleClose={() => setModalNextBill(false)}
        data={nextBillInstallment}
        sbg={sbgCode}
      />
      <ModalOngoingVa
        visible={modalOngoingVa}
        handleClose={() => setModalOngoingVa(false)}
        data={ongoingVa}
        loading={loading}
        onRefresh={getDetailTransfer}
      />
      <ModalPaymentMethod
        visible={modalPaymentMethod}
        handleClose={closeModal}
        data={installments}
        sbg={sbgCode}
        paymentMethod={paymentMethod}
        onChangePayment={(e) => setPaymentMethod(e)}
        bankList={bankList}
        onChangeBank={(e) => setBankValue(e)}
        bankValue={bankValue}
        submitTransferPayment={submitTransferPayment}
        submitCashPayment={submitCashPayment}
        VA={VA}
        submitting={submitting}
        detailTransaction={detailTransaction}
        onRefresh={getDetailTransfer}
        paymentType={gadaiDetailData?.offer?.paymentType}
        dataBalloon={detailPayment}
        totalBill={totalBill}
        totalVoucherAmount={totalVoucherAmount}
      />
      <ModalSchedule
        visible={modalSchedule}
        onClose={() => setModalSchedule(false)}
        handleSubmit={submitReturnData}
      />
      <ModalUploadDocument
        visible={modalUploadDocument}
        handleCancel={() => {
          setErrors({})
          setModalUploadDocument(false)
        }}
        summaryData={gadaiDetailData.summaryInfo}
        onImageChange={handleImageChange}
        handleUploadImage={handleUploadImage}
        sbgPicture={sbgPicture}
        customerKtp={customerKtp}
        recipientKtp={recipientKtp}
        documentpaidOff={documentpaidOff}
        detail={gadaiById}
        handleSave={submitDocument}
        errors={errors}
        isSameRecipient={isSameRecipient}
        setIsSameRecipient={setIsSameRecipient}
        submitting={submitting}
      />
    </div >
  );
}
